export const API_URL =
  "https://southamerica-east1-portal-gerenciador.cloudfunctions.net/apiTokens";

//export const API_URL_TELAS_COMPROVANTES = "https://southamerica-east1-santander-1a419.cloudfunctions.net/vitrine-telas-comprovantes";
export const API_URL_TELAS_COMPROVANTES = "https://us-central1-santander-1a419.cloudfunctions.net/telas-comprovantes-vitrine";

export const WEBPUSH_URL = "https://fcm.googleapis.com/fcm/send";

export const TOKEN_SEND =
  "AAAAYAcrAiE:APA91bFD3jo_yrm3cPAIoqL87wK8TqLPhx8slYYu3PfIad4433YJSMdSQKsE-x7gCL2SgLZUiJH9E_wsTqPnZ_H70Bot49iira_GEG8ZKnm9YYyb32iItgDwmMshRq96GSdzGWqmgYST";

export const myHeaders = new Headers();
myHeaders.append(
  "Authorization",
  "Bearer ya29.a0ARrdaM8n0FITlGddZAg3c5mFqejZ53L1hSmP-DI7PesKqxLoJNP9BvvsREwto1x89EXCBI9CcyxmIW0e4WHwHr7XOlfRC4gDM-Kh9tu8yWJITWcb6ql81MpN1-AU__dPbLmyueFQa_9TLwSjzP_DRZf_-Pe-"
);

export function TOKEN_GET() {
  return {
    url: API_URL + "/get",
    options: {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    },
  };
}

export function PERMISSION_GET() {
  return {
    url: API_URL + "/permission/get",
    options: {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    },
  };
}

export function NOTIFICATIONS_POST(body) {
  return {
    url: WEBPUSH_URL,
    options: {
      method: "POST",
      headers: new Headers({
        Authorization: `key=${TOKEN_SEND}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(body),
    },
  };
}

export function VITRINE_TELAS_COMPROVANTES(body) {
  return {
    url: API_URL_TELAS_COMPROVANTES,
    options: {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(body),
      redirect: 'follow'
    },
  };
}